<script>
  import InfoSateliteView from './InfoSateliteView.svelte';
  import { onMount, setContext, afterUpdate, beforeUpdate } from 'svelte';
  import {
    floodColorScaleBG,
    heatColorScaleBG,
    wildfireColorScaleBG
  } from './stores.js';
  export let facility;
  export let closeInfoBox;
  // console.log(facility);

  function ordinal(i) {
    const last = i.toString().slice(-1);
    switch (last) {
      case '1':
        return 'st';
      case '2':
        return 'nd';
      case '3':
        return 'rd';
      default:
        return 'th';
    }
  }
</script>

<div
  class="pt3 right-bg white z-999 w-100 overflow-y-scroll mobile-list-height h-auto-ns"
>
  <div class="flex justify-between items-start mb1 TIMonoExBold f4 ph3">
    <p class="pv0 mr2 mv0 mh0 w-100">{facility.properties.name}</p>
    <p class="pa0 ma0 pointer f6 TIMono mr1" on:click={closeInfoBox}>
      <img src="TI_Cross_Light.svg" class="h1 w1" alt="Close" />
    </p>
  </div>
  <p class="ttc ph3 pv0 mb1 mt0 mh0 f5">
    {facility.properties.city.toLowerCase()}, {facility.properties.state}
  </p>
  <p class="ttu ph3 pv0 mh0 mt0 mb2 f6 silver">
    {facility.properties.securelvl === 'NOT AVAILABLE'
      ? ''
      : facility.properties.securelvl.toLowerCase()}
    {facility.properties.securelvl === 'JUVENILE' ||
    facility.properties.securelvl === 'NOT AVAILABLE'
      ? ''
      : 'Security '}{facility.properties.type.toLowerCase()}
    Facility{facility.properties.ice_facility === 'Y' ? ' | Ice Facility' : ''}
  </p>
  <ul class="dn-ns list pa0 ma0 f5 flex flex-wrap">
    <li
      class="w-50 tc relative flex flex-wrap items-center info-factor-cube"
      style="background-color: {heatColorScaleBG(
        facility.properties.heat_risk_rating
      )}"
    >
      <div class="w-100 mb4 mt3">
        <div class="ttu w-100 f4 TIExBold">{facility.properties.heat_risk}</div>
        <div class="f6 w-100 ttc">
          {Math.round(facility.properties.hist_90)} Days Above 90
        </div>
      </div>
      <div class="ttu f7 absolute bottom-0 w-100 tc pb2">Heat Risk</div>
    </li>
    <li
      class="w-50 tc relative flex flex-wrap items-center info-factor-cube"
      style="background-color: {wildfireColorScaleBG(
        facility.properties.wildfire_risk_rating
      )}"
    >
      <div class="w-100 mb4 mt3">
        <div class="ttu w-100 f4 TIExBold">
          {facility.properties.wildfire_risk}
        </div>
        <div class="f6 w-100 ttc">
          {Math.round(facility.properties.mean_percentile * 100)}{ordinal(
            Math.round(facility.properties.mean_percentile * 100)
          )} percentile
        </div>
      </div>
      <div class="ttu f7 absolute bottom-0 w-100 tc pb2">Wildfire Risk</div>
    </li>

    <li
      class="w-50 tc relative flex flex-wrap items-center info-factor-cube"
      style="background-color: {facility.properties.confidence === 'low'
        ? 'grey'
        : floodColorScaleBG(facility.properties.flood_risk_rating)}"
    >
      <div class="w-100 mb4 mt3">
        <div class="ttu w-100 f4 TIExBold">
          {facility.properties.flood_risk}
        </div>
        <div class="f6 w-100 ttc">
          {facility.properties.confidence} confidence
        </div>
      </div>
      <div class="ttu f7 absolute bottom-0 w-100 tc pb2">Flood Risk</div>
    </li>
    <li
      class="w-50 tc relative flex flex-wrap items-center info-factor-cube"
      style=""
    >
      <div class="ttu w-100 f4 TIExBold mb4 mt3">
        {facility.properties.status}
      </div>
      <div class="ttu f7 absolute bottom-0 w-100 tc pb2">Facility Status</div>
    </li>
  </ul>
  <p class="ma0 pa0">
    <InfoSateliteView
      geojson={facility}
      centroid={facility.properties.centroid}
    />
  </p>

  <ul class="dn flex-ns list pa0 ma0 f5 flex-wrap">
    <li
      class="w-50 tc relative flex flex-wrap items-center info-factor-box"
      style="background-color: {heatColorScaleBG(
        facility.properties.heat_risk_rating
      )}"
    >
      <div class="w-100 mb4 mt3">
        <div class="ttu w-100 f4 TIExBold">{facility.properties.heat_risk}</div>
        <div class="f6 w-100 ttc">
          {Math.round(facility.properties.hist_90)} Days Above 90
        </div>
      </div>
      <div class="ttu f7 absolute bottom-0 w-100 tc pb2">Heat Risk</div>
    </li>
    <li
      class="w-50 tc relative flex flex-wrap items-center info-factor-box"
      style="background-color: {wildfireColorScaleBG(
        facility.properties.wildfire_risk_rating
      )}"
    >
      <div class="w-100 mb4 mt3">
        <div class="ttu w-100 f4 TIExBold">
          {facility.properties.wildfire_risk}
        </div>
        <div class="f6 w-100 ttc">
          {Math.round(facility.properties.mean_percentile * 100)}{ordinal(
            Math.round(facility.properties.mean_percentile * 100)
          )} percentile
        </div>
      </div>
      <div class="ttu f7 absolute bottom-0 w-100 tc pb2">Wildfire Risk</div>
    </li>

    <li
      class="w-50 tc relative flex flex-wrap items-center info-factor-box"
      style="background-color: {facility.properties.confidence === 'low'
        ? 'grey'
        : floodColorScaleBG(facility.properties.flood_risk_rating)}"
    >
      <div class="w-100 mb4 mt3">
        <div class="ttu w-100 f4 TIExBold">
          {facility.properties.flood_risk}
        </div>
        <div class="f6 w-100 ttc">
          {facility.properties.confidence} confidence
        </div>
      </div>
      <div class="ttu f7 absolute bottom-0 w-100 tc pb2">Flood Risk</div>
    </li>
    <li
      class="w-50 tc relative flex flex-wrap items-center info-factor-box"
      style=""
    >
      <div class="ttu w-100 f4 TIExBold mb4 mt3">
        {facility.properties.status}
      </div>
      <div class="ttu f7 absolute bottom-0 w-100 tc pb2">Facility Status</div>
    </li>
  </ul>
</div>
